import React from "react";
import { serviceLogoUrl } from '../../helpers/ServiceLogo';
import { withRouter } from "react-router-dom";
import { formattedPrice } from "../../helpers/MainHelper";
import "./OfferPreviewScoped.css";

class OfferPreview extends React.Component {
    constructor(props) {
        super(props);
        
        // URL parametrelerinden verileri al
        const searchParams = new URLSearchParams(window.location.search);
        const processesParam = searchParams.get('processes');
        const processes = processesParam ? JSON.parse(decodeURIComponent(processesParam)) : [];
        
        this.state = {
            customer: {
                name: searchParams.get('customer_name') || '',
                surname: searchParams.get('customer_surname') || '',
                phone: searchParams.get('customer_phone') || '',
                email: searchParams.get('customer_email') || '',
                address: searchParams.get('customer_address') || ''
            },
            service: {
                name: searchParams.get('service_name') || '',
                phone: searchParams.get('service_phone') || '',
                email: searchParams.get('service_email') || '',
                address: searchParams.get('service_address') || '',
                logo: searchParams.get('service_logo') || ''
            },
            description: searchParams.get('description') || '',
            processes: processes,
            isDataValid: processes.length > 0 && searchParams.get('customer_name')
        };
    }

    calculateTotals = () => {
        const { processes } = this.state;
        let total = 0;
        let totalKdv = 0;
        let totalDiscount = 0;
        let discountedTotal = 0;

        processes.forEach((item) => {
            const quantity = parseFloat(item.quantity) || 1;
            const price = parseFloat(item.price) || 0;
            const kdvRate = parseFloat(item.kdv) || 0;
            const discountRate = parseFloat(item.discount) || 0;

            const itemTotal = price * quantity;
            const discount = (itemTotal * discountRate) / 100;
            const discountedPrice = itemTotal - discount;
            const kdvAmount = (discountedPrice * kdvRate) / 100;

            total += itemTotal;
            totalDiscount += discount;
            discountedTotal += discountedPrice;
            totalKdv += kdvAmount;
        });

        return {
            total: total.toFixed(2),
            totalKdv: totalKdv.toFixed(2),
            totalDiscount: totalDiscount.toFixed(2),
            discountedTotal: discountedTotal.toFixed(2),
            finalTotal: (discountedTotal + totalKdv).toFixed(2)
        };
    };

    handlePrint = () => {
        window.print();
    };

    handleDownloadPDF = () => {
        // PDF indirme fonksiyonunu daha sonra ekleyebiliriz
        alert('PDF indirme özelliği yakında eklenecek!');
    };

    render() {
        const { customer, service, description, processes, isDataValid } = this.state;
        const { total, totalKdv, totalDiscount, discountedTotal, finalTotal } = this.calculateTotals();
        const currentDate = new Date().toLocaleString('tr-TR');

        if (!isDataValid) {
            return (
                <div className="offer-preview-scoped cs-container">
                    <div className="cs-invoice cs-style1">
                        <div className="cs-invoice_center" style={{ textAlign: 'center', padding: '3rem' }}>
                            <div className="cs-logo cs-mb21">
                                <img style={{ maxWidth: '250px' }} src="https://servicezone.com.tr/assets/img/logo-black.png" alt="servicezone" />
                            </div>
                            <div style={{ color: 'red', fontSize: '1.2rem' }}>
                                Lütfen bilgileri eksiksiz doldurunuz
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="offer-preview-scoped cs-container">
                <div className="cs-invoice cs-style1">
                    <div className="cs-invoice_in" id="download_section">
                        {/* Logo Section */}
                        {service.logo && (
                            <div className="cs-invoice_left cs-text_center" style={{ maxWidth: '100%' }}>
                                <div className="cs-logo cs-mb5">
                                    <img 
                                        crossOrigin="anonymous" 
                                        src={serviceLogoUrl(service)}
                                        alt={service.name} 
                                    />
                                </div>
                            </div>
                        )}

                        {/* Header */}
                        <div className="cs-invoice_head cs-type1 cs-mb25">
                            <div className="cs-invoice_left">
                                <p className="cs-invoice_date cs-primary_color cs-m0">
                                    <b className="cs-primary_color">Tarih: </b>{currentDate}
                                </p>
                            </div>
                            <div className="cs-invoice_center">
                                <p className="cs-invoice_date cs-primary_color cs-m0">
                                    <b className="cs-primary_color">Teklif Formu</b>
                                </p>
                            </div>
                            <div className="cs-invoice_right" aria-hidden="true" />
                        </div>

                        {/* Service and Customer Info */}
                        <div className="cs-invoice_head cs-mb10">
                            <div className="cs-invoice_left">
                                <b className="cs-primary_color">Servis:</b>
                                <p>
                                    {service.name.toUpperCase()}<br />
                                    {service.phone || "Belirtilmemiş"}<br />
                                    {service.email || "Belirtilmemiş"}<br />
                                    {service.address?.toUpperCase() || "Belirtilmemiş"}
                                </p>
                            </div>
                            <div className="cs-invoice_right cs-text_right">
                                <b className="cs-primary_color">Müşteri</b>
                                <p>
                                    {customer.name.toUpperCase()} {customer.surname.toUpperCase()}<br />
                                    {customer.phone || "Belirtilmemiş"}<br />
                                    {customer.email || "Belirtilmemiş"}<br />
                                    {customer.address?.toUpperCase() || "Belirtilmemiş"}
                                </p>
                            </div>
                        </div>

                        {/* Description */}
                        {description && (
                            <div className="cs-table cs-style1" style={{ marginTop: '15px' }}>
                                <div className="cs-round_border">
                                    <div className="cs-table_responsive">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th className="cs-width_6 cs-semi_bold cs-primary_color cs-focus_bg">
                                                        Detay
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="cs-width_6">{description}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Processes Table */}
                        <div className="cs-table cs-style1" style={{ marginTop: '15px' }}>
                            <div className="cs-round_border">
                                <div className="cs-table_responsive">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className="cs-width_3 cs-semi_bold cs-primary_color cs-focus_bg">
                                                    Yapılan İşlem
                                                </th>
                                                <th className="cs-width_3 cs-semi_bold cs-primary_color cs-focus_bg">
                                                    Fiyat
                                                </th>
                                                <th className="cs-width_3 cs-semi_bold cs-primary_color cs-focus_bg">
                                                    KDV
                                                </th>
                                                <th className="cs-width_3 cs-semi_bold cs-primary_color cs-focus_bg">
                                                    İndirim
                                                </th>
                                                <th className="cs-width_3 cs-semi_bold cs-primary_color cs-focus_bg">
                                                    İndirimli Fiyat
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {processes.map((item, index) => {
                                                const quantity = parseFloat(item.quantity) || 1;
                                                const price = parseFloat(item.price) || 0;
                                                const itemTotal = price * quantity;
                                                const discount = item.discount ? (itemTotal * (item.discount / 100)) : 0;
                                                const discountedPrice = itemTotal - discount;
                                                const kdv = (discountedPrice * (item.kdv / 100));

                                                return (
                                                    <tr key={index}>
                                                        <td className="cs-width_3">{item.process.toUpperCase()}</td>
                                                        <td className="cs-width_3">{itemTotal.toFixed(2)}₺</td>
                                                        <td className="cs-width_3">{kdv.toFixed(2)}₺</td>
                                                        <td className="cs-width_3">{item.discount ? item.discount + '%' : '0%'}</td>
                                                        <td className="cs-width_3">{discountedPrice.toFixed(2)}₺</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Footer Totals */}
                                <div className="cs-invoice_footer cs-border_top">
                                    <div className="cs-left_footer cs-mobile_hide">
                                        <p className="cs-mb0"><b className="cs-primary_color">Bilgilendirme:</b></p>
                                        <p className="cs-m0">
                                            Bu formdaki içerikler ve fiyatlar, servisin <br />
                                            gereksinimlerine ve müşteri tercihlerine göre değişebilir.
                                        </p>
                                    </div>
                                    <div className="cs-right_footer">
                                        <table>
                                            <tbody>
                                                <tr className="cs-border_left">
                                                    <td className="cs-width_3 cs-semi_bold cs-primary_color cs-focus_bg">
                                                        Ara Toplam
                                                    </td>
                                                    <td className="cs-width_3 cs-semi_bold cs-focus_bg cs-primary_color cs-text_right">
                                                        {formattedPrice(total)}
                                                    </td>
                                                </tr>
                                                <tr className="cs-border_left">
                                                    <td className="cs-width_3 cs-semi_bold cs-primary_color cs-focus_bg">
                                                        İndirimli Ara Toplam
                                                    </td>
                                                    <td className="cs-width_3 cs-semi_bold cs-focus_bg cs-primary_color cs-text_right">
                                                        {formattedPrice(discountedTotal)}
                                                    </td>
                                                </tr>
                                                <tr className="cs-border_left">
                                                    <td className="cs-width_3 cs-semi_bold cs-primary_color cs-focus_bg">
                                                        Toplam KDV
                                                    </td>
                                                    <td className="cs-width_3 cs-semi_bold cs-focus_bg cs-primary_color cs-text_right">
                                                        {formattedPrice(totalKdv)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="cs-invoice_footer">
                                    <div className="cs-left_footer cs-mobile_hide"></div>
                                    <div className="cs-right_footer">
                                        <table>
                                            <tbody>
                                                <tr className="cs-border_none">
                                                    <td className="cs-width_3 cs-border_top_0 cs-bold cs-f16 cs-primary_color">
                                                        Ödenecek Tutar
                                                    </td>
                                                    <td className="cs-width_3 cs-border_top_0 cs-bold cs-f16 cs-primary_color cs-text_right">
                                                        {formattedPrice(finalTotal)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Note */}
                        <div className="cs-note">
                            <div className="cs-note_left">
                                <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512">
                                    <path d="M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="32" />
                                    <path d="M256 56v120a32 32 0 0032 32h120M176 288h160M176 368h160" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" />
                                </svg>
                            </div>
                            <div className="cs-note_right">
                                <p className="cs-mb0"><b className="cs-primary_color cs-bold">Not:</b></p>
                                <p className="cs-m0">Bu rapor bilgisayar tarafından üretilmiştir ve fiziksel imza gerektirmez.</p>
                            </div>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="cs-invoice_btns cs-hide_print">
                        <button onClick={this.handlePrint} className="cs-invoice_btn cs-color1">
                            <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512">
                                <path d="M384 368h24a40.12 40.12 0 0040-40V168a40.12 40.12 0 00-40-40H104a40.12 40.12 0 00-40 40v160a40.12 40.12 0 0040 40h24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="32" />
                                <rect x="128" y="240" width="256" height="208" rx="24.32" ry="24.32" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="32" />
                                <path d="M384 128v-24a40.12 40.12 0 00-40-40H168a40.12 40.12 0 00-40 40v24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="32" />
                                <circle cx="392" cy="184" r="24" />
                            </svg>
                            <span>Yazdır</span>
                        </button>

                        <button onClick={() => this.props.history.goBack()} className="cs-invoice_btn cs-color2" style={{ background: '#6c757d' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512">
                                <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M244 400L100 256l144-144M120 256h292" />
                            </svg>
                            <span>Geri Dön</span>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(OfferPreview);
